export default "__VITE_ASSET__CYFlwP1r__"